import LearnCoin from '@/modules/knowledge-operation/share-output/output-learncoin-manage/learningcoin-shell.vue';


export default (Vue) => {
    const Instance = Vue.extend({
        render: h => h(LearnCoin)
    });
    Vue.prototype.$createCoin = () => new Instance();
};
